import { GuestStatus } from "@/types/guest";

export const GUEST_STATUS_FILTER_DEFAULT = "guest status";

export const CHECKED_OUT_GUEST_STATUS = "Checked out";

export const RESERVATION_GUEST_STATUS_OPTIONS = [
  GuestStatus.BEFORE_CHECK_IN,
  GuestStatus.PRE_CHECKIN,
  GuestStatus.IN_HOUSE,
  GuestStatus.BEFORE_CHECK_OUT,
  GuestStatus.PRE_CHECKOUT,
  CHECKED_OUT_GUEST_STATUS,
] as const;

export type ReservationGuestStatusFilter =
  (typeof RESERVATION_GUEST_STATUS_OPTIONS)[number];
